import { get, destroy, upload, uploadPut } from 'utils/fetchRequest';

export const getTimeline = async (search) => {
    try {
        return await get(`timeline${search ? `?search=${search}` : ''}`);
    } catch (err) {
        return { error: err };
    }
};

// Зөвхөн нүүр хуудсанд онцлохоор тэмдэглэсэн үе шатууд
export const getTimelineHighlights = async () => {
    try {
        return await get('timeline?highlight=true');
    } catch (err) {
        return { error: err };
    }
};

export const getTimelineItem = async (id) => {
    try {
        return await get(`timeline/${id}`);
    } catch (err) {
        return { error: err };
    }
};

export const createTimeline = async (formData) => {
    try {
        return await upload('timeline', formData);
    } catch (err) {
        return { error: err };
    }
};

export const updateTimeline = async (id, formData) => {
    try {
        return await uploadPut(`timeline/${id}`, formData);
    } catch (err) {
        return { error: err };
    }
};

export const deleteTimeline = async (id) => {
    try {
        return await destroy(`timeline/${id}`);
    } catch (err) {
        return { error: err };
    }
};